<template>
    <div class="tab-history-wrap section-space--mt_80">
        <div class="row align-items-center">
            <div class="col-lg-7">
                <div class="tab-history-image">
                    <img src="../../assets/img/trustami/keywords_highlight.svg" alt="" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-5">
                <div class="tab-content-inner">
                    <h4 class="font-weight--light mb-25">{{ $t("keyw.highlights_and_features") }}</h4>
                    <ul class="check-list green-check-list mb-30">
                        <li class="list-item">{{ $t("keyw.highlight_1") }}</li>
                        <li class="list-item">{{ $t("keyw.highlight_2") }}</li>
                        <li class="list-item">{{ $t("keyw.highlight_3") }}</li>
                        <li class="list-item">{{ $t("keyw.highlight_4") }}</li>
                        <li class="list-item" v-html="$t('keyw.highlight_5')"></li>
                        <li class="list-item">{{ $t("keyw.highlight_6") }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabContentOne'
}
</script>
